import { sendJsonPayloadClient } from './api-main';
import { LoadCacheStatus } from '../models/plans/LoadCacheStatus';

export const getPlansCacheStatus = async (): Promise<LoadCacheStatus> => {
  try {
    const response = await sendJsonPayloadClient.get<LoadCacheStatus>(
      '/analyzer/plansCacheStatus',
    );
    if (response?.data && response.status === 200) {
      return response.data as LoadCacheStatus;
    } else {
      throw new Error(`Unexpected response. Response: '${response}'`);
    }
  } catch (error) {
    console.error('Error fetching plans cache status:', error);
    throw error;
  }
};
